export const orders = [
    {
        id: 1,
        category: "new",
        orderNum: 8549,
        time: '21:32',
        customer: "Muhammad Ali",
        phoneNum: "+8201091519002",
        cost: "35,400 KRW",
        deliveringCost: "5000 KRW",
        total: "40000 KRW",
        paymentType: "Payme",
        operator: "Komila A",
        branch: "Suwon City",
        order: [
            {
                id: 1,
                type: "Burger standard",
                cost: 6000,
                count: 4
            },
            {
                id: 2,
                type: "Bread Sandwich",
                cost: 5000,
                count: 2
            },
            {
                id: 3,
                type: "Coca-Cola 1.5L",
                cost: 3500,
                count: 1
            },

        ]
    },
    {
        id: 2,
        category: "new",
        orderNum: 8534,
        time: '21:32',
        customer: "Deveeprasad Acharya",
        phoneNum: "+8201091519002",
        cost: "35,400 KRW",
        deliveringCost: "5000 KRW",
        total: "40000 KRW",
        paymentType: "Payme",
        operator: "Komila A",
        branch: "Suwon City",
        order: [
            {
                id: 1,
                type: "Burger standard",
                cost: 6000,
                count: 4
            },
            {
                id: 2,
                type: "Bread Sandwich",
                cost: 5000,
                count: 2
            },
            {
                id: 3,
                type: "Coca-Cola 1.5L",
                cost: 3500,
                count: 1
            },
        ]
    },
    {
        id: 3,
        category: "new",
        orderNum: 8522,
        time: '21:32',
        customer: "Thoma Fulloway",
        phoneNum: "+8201091519002",
        cost: "35,400 KRW",
        deliveringCost: "5000 KRW",
        total: "40000 KRW",
        paymentType: "Payme",
        operator: "Komila A",
        branch: "Suwon City",
        order: [
            {
                id: 1,
                type: "Burger standard",
                cost: 6000,
                count: 4
            },
            {
                id: 2,
                type: "Bread Sandwich",
                cost: 5000,
                count: 2
            },
            {
                id: 3,
                type: "Coca-Cola 1.5L",
                cost: 3500,
                count: 1
            },
        ]
    },
    {
        id: 4,
        category: "new",
        orderNum: 8512,
        time: '21:32',
        customer: "Jaquelin Likoki",
        phoneNum: "+8201091519002",
        cost: "35,400 KRW",
        deliveringCost: "5000 KRW",
        total: "40000 KRW",
        paymentType: "Payme",
        operator: "Komila A",
        branch: "Suwon City",
        order: [
            {
                id: 1,
                type: "Burger standard",
                cost: 6000,
                count: 4
            },
            {
                id: 2,
                type: "Bread Sandwich",
                cost: 5000,
                count: 2
            },
            {
                id: 3,
                type: "Coca-Cola 1.5L",
                cost: 3500,
                count: 1
            },
        ]
    },
    {
        id: 5,
        category: "received",
        orderNum: 8512,
        time: '21:32',
        customer: "Jaquelin Likoki",
        phoneNum: "+8201091519002",
        cost: "35400 KRW",
        deliveringCost: "5000 KRW",
        total: "40000 KRW",
        paymentType: "Payme",
        operator: "Komila A",
        branch: "Suwon City",
        order: [
            {
                id: 1,
                type: "Burger standard",
                cost: 6000,
                count: 4
            },
            {
                id: 2,
                type: "Bread Sandwich",
                cost: 5000,
                count: 2
            },
            {
                id: 3,
                type: "Coca-Cola 1.5L",
                cost: 3500,
                count: 1
            },
        ]
    },
    {
        id: 6,
        category: "sent",
        orderNum: 8512,
        time: '21:32',
        customer: "Jaquelin Likoki",
        phoneNum: "+8201091519002",
        cost: "35400 KRW",
        deliveringCost: "5000 KRW",
        total: "40000 KRW",
        paymentType: "Payme",
        operator: "Komila A",
        branch: "Suwon City",
        order: [
            {
                id: 1,
                type: "Burger standard",
                cost: 6000,
                count: 4
            },
            {
                id: 2,
                type: "Bread Sandwich",
                cost: 5000,
                count: 2
            },
            {
                id: 3,
                type: "Coca-Cola 1.5L",
                cost: 3500,
                count: 1
            },
        ]
    },
    {
        id: 7,
        category: "sent",
        orderNum: 8512,
        time: '21:32',
        customer: "Jaquelin Likoki",
        phoneNum: "+8201091519002",
        cost: "35400 KRW",
        deliveringCost: "5000 KRW",
        total: "40000 KRW",
        paymentType: "Payme",
        operator: "Komila A",
        branch: "Suwon City",
        order: [
            {
                id: 1,
                type: "Burger standard",
                cost: 6000,
                count: 4
            },
            {
                id: 2,
                type: "Bread Sandwich",
                cost: 5000,
                count: 2
            },
            {
                id: 3,
                type: "Coca-Cola 1.5L",
                cost: 3500,
                count: 1
            },
        ]
    },
    {
        id: 8,
        category: "closed",
        orderNum: 8512,
        time: '21:32',
        customer: "Jaquelin Likoki",
        phoneNum: "+8201091519002",
        cost: "35400 KRW",
        deliveringCost: "5000 KRW",
        total: "40000 KRW",
        paymentType: "Payme",
        operator: "Komila A",
        branch: "Suwon City",
        order: [
            {
                id: 1,
                type: "Burger standard",
                cost: 6000,
                count: 4
            },
            {
                id: 2,
                type: "Bread Sandwich",
                cost: 5000,
                count: 2
            },
            {
                id: 3,
                type: "Coca-Cola 1.5L",
                cost: 3500,
                count: 1
            },
        ]
    },
    {
        id: 9,
        category: "closed",
        orderNum: 8512,
        time: '21:32',
        customer: "Jaquelin Likoki",
        phoneNum: "+8201091519002",
        cost: "35500 KRW",
        deliveringCost: "5000 KRW",
        total: "40000 KRW",
        paymentType: "Payme",
        operator: "Komila A",
        branch: "Suwon City",
        order: [
            {
                id: 1,
                type: "Burger standard",
                cost: 6000,
                count: 4
            },
            {
                id: 2,
                type: "Bread Sandwich",
                cost: 5000,
                count: 2
            },
            {
                id: 3,
                type: "Coca-Cola 1.5L",
                cost: 3500,
                count: 1
            },
        ]
    },
    {
        id: 10,
        category: "closed",
        orderNum: 8512,
        time: '21:32',
        customer: "Jaquelin Likoki",
        phoneNum: "+8201091519002",
        cost: "35000 KRW",
        deliveringCost: "5000 KRW",
        total: "40000 KRW",
        paymentType: "Payme",
        operator: "Komila A",
        branch: "Suwon City",
        order: [
            {
                id: 1,
                type: "Burger standard",
                cost: 6000,
                count: 4
            },
            {
                id: 2,
                type: "Bread Sandwich",
                cost: 5000,
                count: 2
            },
            {
                id: 3,
                type: "Coca-Cola 1.5L",
                cost: 3500,
                count: 1
            },
        ]
    }
]